/**
 * Header decoration/icon for a preference type category.
 *
 * Belongs here: header SVG or fund list UI.
 * Does not belong here: questionnaire flow.
 */
/** ELSS, retirement, children — also used as the header icon fallback. */
export function GoalBasedPreferenceHeaderIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="160"
      viewBox="0 0 130 160"
      fill="none"
      className={className}
      aria-hidden
    >
      <g clipPath="url(#clip0_99328_278974)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.02103 5.02103C8.23593 1.80611 12.5963 0 17.1429 0H91.4286C92.9441 0 94.3975 0.602039 95.4691 1.67368L135.47 41.6737C136.541 42.7453 137.143 44.1987 137.143 45.7143V65.7143H91.4286C77.227 65.7143 65.7143 77.227 65.7143 91.4286V106.717C65.7143 127.646 74.9978 146.946 90.2351 160H17.1429C12.5962 160 8.23593 158.194 5.02103 154.979C1.80611 151.765 0 147.403 0 142.857V17.1429C0 12.5963 1.80611 8.23593 5.02103 5.02103ZM27.1429 45.7143C27.1429 41.7694 30.3408 38.5714 34.2857 38.5714H91.4286C95.3735 38.5714 98.5714 41.7694 98.5714 45.7143C98.5714 49.6592 95.3735 52.8571 91.4286 52.8571H34.2857C30.3408 52.8571 27.1429 49.6592 27.1429 45.7143ZM34.2857 72.8571C30.3408 72.8571 27.1429 76.0551 27.1429 80C27.1429 83.9449 30.3408 87.1429 34.2857 87.1429H47.1429C51.0878 87.1429 54.2857 83.9449 54.2857 80C54.2857 76.0551 51.0878 72.8571 47.1429 72.8571H34.2857ZM27.1429 114.286C27.1429 110.341 30.3408 107.143 34.2857 107.143H47.1429C51.0878 107.143 54.2857 110.341 54.2857 114.286C54.2857 118.231 51.0878 121.429 47.1429 121.429H34.2857C30.3408 121.429 27.1429 118.231 27.1429 114.286ZM91.4286 80C85.1168 80 80 85.1168 80 91.4286V106.717C80 130.759 95.3845 152.104 118.193 159.706C119.366 160.098 120.634 160.098 121.807 159.706C144.616 152.104 160 130.759 160 106.717V91.4286C160 85.1168 154.883 80 148.571 80H91.4286ZM139.336 100.664C142.126 103.453 142.126 107.976 139.336 110.765L119.336 130.765C116.547 133.554 112.024 133.554 109.235 130.765L100.664 122.193C97.8741 119.405 97.8741 114.881 100.664 112.092C103.453 109.303 107.976 109.303 110.765 112.092L114.286 115.613L129.235 100.664C132.024 97.8741 136.547 97.8741 139.336 100.664Z"
          fill="#CFDBDB"
        />
      </g>
      <defs>
        <clipPath id="clip0_99328_278974">
          <rect width="160" height="160" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
